<div class="search-bar">
    <div class="bar">
        <label for="">Pesquisar</label>
        <div class="field">
            <input type="text" placeholder="{{ placeholder }}" class="campos" (input)="searchItens($event.target.value)" />

            <img src="../../../../../../assets/icons/search.svg" alt="Ícone de lupa">
        </div>
    </div>
</div>